import * as React from 'react';

import { DrawerContext } from '@notino/react-styleguide';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { ColorCirclePicker } from './ColorCirclePicker';
import { ShadeDrawerArgs } from './model';
import {
  Title,
  ShadesVariantsList,
  StyledDrawerHeader,
  StyledDrawerContent,
} from './styled';
import {
  trackDrawerOpen,
  trackResizeToTop,
  trackResizeToMiddle,
  trackDrawerClose,
} from './tracking';

const VARIANT_LENGTH_FOR_TOP_DRAWER_POSITION = 10;

export const useShadesDrawer = ({
  variants,
  selectedId,
  shadeDrawerTitle,
  onClick,
}: ShadeDrawerArgs) => {
  const { openDrawer, closeDrawer } = DrawerContext.useDrawerContext();
  const { getTimeFromInit: getTime } = useTrackingContext();
  const { product } = useProductDetailContext();

  const handleOpenDrawer = () => {
    trackDrawerOpen({ timing: getTime() });
    openDrawer(
      <ShadesVariantsList>
        {variants.map((item) => (
          <ColorCirclePicker
            item={item}
            isSelected={item.webId === selectedId}
            key={item.webId}
            getTimeFromInit={getTime}
            product={product}
            onClick={onClick}
          />
        ))}
      </ShadesVariantsList>,
      {
        initialPosition:
          variants.length >= VARIANT_LENGTH_FOR_TOP_DRAWER_POSITION
            ? 'top'
            : 'dynamic',
        title: <Title>{shadeDrawerTitle}</Title>,
        interceptBrowserBackButtonToCloseDrawer: true,
        onClose: (closeType) => {
          trackDrawerClose({ closeType, timing: getTime() });
          closeDrawer();
        },
        onResizeToTop: () => trackResizeToTop({ timing: getTime() }),
        onResizeToMiddle: () => trackResizeToMiddle({ timing: getTime() }),
        headerCustomStyles: StyledDrawerHeader,
        drawerContainerCustomStyles: StyledDrawerContent,
      }
    );
  };

  return { handleOpenDrawer };
};
